import { useConfiguration } from '~/context/common/StaticContext';
import { useGetYmmtWhyBuy } from '~/context/vdp/VehicleContext';
import type { NarrativeMedia } from '~/contracts/vdp/Narratives';
import useGetVaultWhyBuyNarrative from '../useGetVaultWhyBuyNarrative';
import useShowVaultWhyBuyContent from '../useHasVaultWhyBuyData';

type VersionType = 'v2-vin' | 'v1-vault-treatment' | 'ymmt';

type WhyBuyData = {
  type?: VersionType;
  summary?: string | null;
  bulletPoints?: Array<{
    bulletType?: string;
    content?: string | null;
    cvnaFeatureIds?: Array<string> | null;
    media?: NarrativeMedia | null;
    title?: string | null;
  }> | null;
};

function useGetNarrativeVersionType() {
  const {
    VaultWhyBuyNarrativeConfig: {
      bucket: { control = '', treatment = '' } = {}
    } = {}
  } = useConfiguration();
  const { narrativeVersion = '' } = useGetVaultWhyBuyNarrative();

  if (narrativeVersion === control) return 'v2-vin';
  if (narrativeVersion === treatment) return 'v1-vault-treatment';

  return undefined;
}

export default function useWhyBuyData(): WhyBuyData {
  const vaultWhyBuyContentExists = useShowVaultWhyBuyContent();
  const vaultVersionType = useGetNarrativeVersionType();
  const { narrativeContent } = useGetVaultWhyBuyNarrative();
  const ymmtWhyBuyData = useGetYmmtWhyBuy();

  return vaultWhyBuyContentExists
    ? {
        type: vaultVersionType,
        bulletPoints: narrativeContent?.bulletPoints,
        summary: narrativeContent?.summary
      }
    : {
        type: 'ymmt',
        bulletPoints: ymmtWhyBuyData?.bulletPoints,
        summary: ymmtWhyBuyData?.summary
      };
}
